import type ModalConversationInterceptorService from '../../modals/modal-conversation-interceptor.service';

export class UserInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService) {
    }

    public register() {
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserHasDebtOnRegistrationFeeException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserHasReservationReadyException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserHasReservationException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserIsMemberOfGroupException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserIsRepresentativeOfGroupException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('GroupHasMembersException');

        this.modalConversationInterceptor.registerUserPreferenceExceptionHandler('UserPreferenceNotSetException');

    }

}
